import Scans from './Constructor'

export default Scans
export { Scans }
